/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HandPointClickBIcon16Light } from './HandPointClickBIcon16Light';
import { HandPointClickBIcon16Regular } from './HandPointClickBIcon16Regular';
import { HandPointClickBIcon16Solid } from './HandPointClickBIcon16Solid';
import { HandPointClickBIcon20Light } from './HandPointClickBIcon20Light';
import { HandPointClickBIcon20Regular } from './HandPointClickBIcon20Regular';
import { HandPointClickBIcon20Solid } from './HandPointClickBIcon20Solid';
import { HandPointClickBIcon24Regular } from './HandPointClickBIcon24Regular';
import { HandPointClickBIcon24Solid } from './HandPointClickBIcon24Solid';
import { HandPointClickBIcon32Regular } from './HandPointClickBIcon32Regular';
import { HandPointClickBIcon64Regular } from './HandPointClickBIcon64Regular';
var sizes = {
    16: {
        light: HandPointClickBIcon16Light,
        regular: HandPointClickBIcon16Regular,
        solid: HandPointClickBIcon16Solid,
    },
    20: {
        light: HandPointClickBIcon20Light,
        regular: HandPointClickBIcon20Regular,
        solid: HandPointClickBIcon20Solid,
    },
    24: {
        regular: HandPointClickBIcon24Regular,
        solid: HandPointClickBIcon24Solid,
    },
    32: {
        regular: HandPointClickBIcon32Regular,
    },
    64: {
        regular: HandPointClickBIcon64Regular,
    },
};
export var HandPointClickBIcon = forwardRef('HandPointClickBIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
